const translation = {
  // NAVBAR
  nav_home: 'Inicio',
  nav_water: 'Purificación de Agua',
  nav_windows: 'Servicios de Ventanas',
  nav_quote: 'Cotización Gratis',

  // FOOTER
  footer_desc: 'ORPM Investment LLC ofrece sistemas premium de purificación de agua y soluciones profesionales de ventanas para propietarios y negocios en Georgia. Mejorando vidas, un hogar a la vez.',
  footer_quick_links: 'Enlaces Rápidos',
  footer_our_services: 'Nuestros Servicios',
  footer_contact_us: 'Contáctanos',
  footer_address: '3202 Lealand Pl Ln\nLawrenceville, GA 30044',
  footer_hours: 'Lun – Vie: 8am – 6pm\nSáb: 9am – 3pm',
  footer_copyright: '© 2026 ORPM Investment LLC. Todos los derechos reservados.',
  footer_licensed: 'Con Licencia y Asegurado en Georgia',
  footer_privacy: 'Política de Privacidad',
  footer_terms: 'Términos de Uso',
  footer_svc1: 'Filtración para Todo el Hogar',
  footer_svc2: 'Sistemas de Agua Potable',
  footer_svc3: 'Suavizadores de Agua',
  footer_svc4: 'Instalación de Ventanas',
  footer_svc5: 'Reemplazo de Ventanas',
  footer_svc6: 'Ventanas Comerciales',

  // HERO
  hero_badge: 'Sirviendo Propietarios y Negocios',
  hero_title1: 'Mejor Agua.',
  hero_title2: 'Mejor Vida.',
  hero_title3: 'Mejores Hogares.',
  hero_subtitle: 'Purificación de agua avanzada y soluciones profesionales de ventanas para su hogar o negocio. La confianza de miles de familias.',
  hero_cta_water: 'Prueba de Agua Gratis',
  hero_cta_windows: 'Cotización de Ventanas',
  hero_trust1: 'Con Licencia y Asegurado',
  hero_trust2: 'Calificación 5 Estrellas',
  hero_trust3: 'Más de 15 Años de Experiencia',
  hero_trust4: 'Consultas Gratuitas',

  // SERVICES OVERVIEW
  svc_tag: 'Lo Que Ofrecemos',
  svc_title: 'Dos Servicios. Un Socio de Confianza.',
  svc_desc: 'ORPM Investment LLC reúne dos servicios esenciales de mejoras para el hogar bajo un mismo techo — para que pueda confiar en nosotros con todo lo que más importa.',
  svc_water_title: 'Sistemas de Purificación de Agua',
  svc_water_sub: 'Agua Limpia para una Vida más Saludable',
  svc_water_desc: 'Nuestros sistemas avanzados de filtración eliminan hasta el 99.9% de los contaminantes — incluyendo cloro, plomo, bacterias y metales pesados — entregando agua pura y de excelente sabor en cada grifo de su hogar.',
  svc_water_b1: 'Filtración para todo el hogar y sistemas de bebida',
  svc_water_b2: 'Suavizadores y acondicionadores de agua',
  svc_water_b3: 'Equipos certificados NSF/ANSI',
  svc_water_b4: 'Instalación y servicio profesional',
  svc_water_cta: 'Explorar Sistemas de Agua',
  svc_water_badge: 'Purificación de Agua',
  svc_win_title: 'Venta e Instalación de Ventanas',
  svc_win_sub: 'Ventanas Premium para Comodidad y Eficiencia',
  svc_win_desc: 'Desde casas unifamiliares hasta edificios comerciales, nuestras ventanas de alto rendimiento ofrecen aislamiento superior, reducción de ruido y ahorro energético — instaladas profesionalmente y respaldadas por garantía de por vida.',
  svc_win_b1: 'Instalación residencial y comercial',
  svc_win_b2: 'Ventanas certificadas Energy Star',
  svc_win_b3: 'Reducción de ruido y protección UV',
  svc_win_b4: 'Tamaños personalizados y opciones resistentes a impactos',
  svc_win_cta: 'Explorar Servicios de Ventanas',
  svc_win_badge: 'Servicios de Ventanas',

  // BENEFITS
  ben_tag: 'Por Qué Importa',
  ben_title1: 'Beneficios Reales para',
  ben_title2: 'Propietarios Reales',
  ben_desc: 'Invertir en calidad del agua y mejores ventanas genera mejoras medibles en su salud, comodidad y valor de su hogar.',
  ben1_title: 'Salud y Bienestar',
  ben1_desc: 'El agua pura reduce la exposición a contaminantes dañinos vinculados a problemas de salud. Agua limpia significa mejor hidratación, cocina y bienestar para toda su familia.',
  ben1_stat_label: 'Eliminación de Contaminantes',
  ben2_title: 'Eficiencia Energética',
  ben2_desc: 'Nuestras ventanas certificadas Energy Star reducen los costos de calefacción y refrigeración hasta un 40%, manteniendo su hogar cómodo todo el año y reduciendo su huella de carbono.',
  ben2_stat_label: 'Ahorro en Costos de Energía',
  ben3_title: 'Aumento del Valor del Hogar',
  ben3_desc: 'Las ventanas mejoradas y los sistemas de agua limpia aumentan significativamente el valor de la propiedad. Los compradores buscan activamente hogares con estas mejoras premium.',
  ben3_stat_label: 'Aumento del Valor de la Propiedad',
  ben4_title: 'Calidad Garantizada',
  ben4_desc: 'Cada sistema e instalación está respaldado por nuestra garantía de satisfacción y la garantía del fabricante. Respaldamos nuestro trabajo al 100% — sin preguntas.',
  ben4_stat_label: 'Satisfacción Garantizada',

  // WHY CHOOSE US
  why_tag: 'Por Qué Elegirnos',
  why_title1: 'Su Socio de Confianza en',
  why_title2: 'Mejoras para el Hogar',
  why_desc: 'Llevamos más de 15 años sirviendo a propietarios y negocios, construyendo una reputación de calidad, confiabilidad y servicio honesto. Al elegir ORPM, elige un socio que se preocupa tanto por su hogar como usted.',
  why_stat1: 'Años de Experiencia',
  why_stat2: 'Clientes Satisfechos',
  why_stat3: 'Servicios Especializados',
  why_stat4: 'Con Licencia y Asegurado',
  why_r1_title: 'Profesionales Certificados',
  why_r1_desc: 'Nuestros técnicos están certificados por WQA y capacitados en Energy Star. Solo usamos equipos que cumplen o superan los estándares NSF/ANSI y EPA.',
  why_r2_title: 'Servicio al Cliente de Primera Clase',
  why_r2_desc: 'Desde su primera llamada hasta el seguimiento post-instalación, hacemos que todo el proceso sea fácil, transparente y libre de estrés para cada cliente.',
  why_r3_title: 'Instalaciones Limpias y Eficientes',
  why_r3_desc: 'Respetamos su hogar. Nuestros equipos llegan a tiempo, trabajan limpiamente y siempre dejan el espacio mejor de como lo encontraron.',
  why_r4_title: 'Precios Transparentes, Sin Sorpresas',
  why_r4_desc: 'Obtenga una cotización detallada antes de que comience cualquier trabajo. Sin tarifas ocultas, sin ventas adicionales, sin presión — solo precios honestos y valor real.',

  // TESTIMONIALS
  test_tag: 'Testimonios de Clientes',
  test_title: 'Lo Que Dicen Nuestros Clientes',
  test_desc: 'Historias reales de propietarios que transformaron sus hogares con ORPM Investment LLC.',
  test1_text: 'Antes de ORPM, me preocupaba la calidad del agua. Después de instalar su sistema de filtración, la diferencia es increíble. El agua sabe genial y ya no me preocupo por lo que beben mis hijos. El equipo de instalación fue muy profesional.',
  test1_name: 'Sarah Mitchell',
  test1_loc: 'Lawrenceville, GA',
  test1_svc: 'Purificación de Agua',
  test2_text: 'ORPM reemplazó las 14 ventanas de mi casa y la transformación es increíble. ¡Mi factura de electricidad bajó $180 el primer mes! Las nuevas ventanas también bloquean mucho el ruido. Los recomiendo ampliamente.',
  test2_name: 'Robert Keller',
  test2_loc: 'Lawrenceville, GA',
  test2_svc: 'Instalación de Ventanas',
  test3_text: 'Usamos ORPM para un purificador para el hogar y ventanas nuevas. Tener una sola empresa para ambos fue muy conveniente. El equipo fue respetuoso, puntual y la calidad del trabajo es sobresaliente. ¡Valió cada centavo!',
  test3_name: 'Maria & Carlos Lopez',
  test3_loc: 'Lawrenceville, GA',
  test3_svc: 'Agua + Ventanas',

  // TRUST BADGES
  trust_label: 'De Confianza, Certificados y Respaldados por Líderes de la Industria',
  trust1_title: 'Con Licencia y Asegurado',
  trust1_sub: 'Certificado en Georgia',
  trust2_title: 'Acreditado BBB',
  trust2_sub: 'Calificación A+',
  trust3_title: 'Energy Star',
  trust3_sub: 'Socio Certificado',
  trust4_title: 'Certificado WQA',
  trust4_sub: 'Calidad del Agua',
  trust5_title: 'Certificado NSF',
  trust5_sub: 'Equipos Probados',
  trust6_title: 'Calificación 5 Estrellas',
  trust6_sub: 'Reseñas en Google',

  // HOME CTA
  cta_tag: 'Da el Primer Paso',
  cta_title1: '¿Listo para Transformar',
  cta_title2: 'Tu Hogar?',
  cta_desc: 'Programe su consulta gratuita hoy. Ya sea agua más limpia o ventanas más eficientes — estamos aquí para ayudarle a mejorar su hogar y calidad de vida.',
  cta_water: 'Prueba de Agua Gratis',
  cta_windows: 'Cotización de Ventanas Gratis',
  cta_note: 'Sin obligación · Consulta gratuita · Profesionales con licencia',

  // WATER HERO
  wh_back: 'Volver al Inicio',
  wh_badge: 'Purificación de Agua',
  wh_title1: 'Agua Limpia para una',
  wh_title2: 'Vida más Saludable',
  wh_desc: 'Deje de preocuparse por lo que hay en su agua. Nuestros sistemas avanzados de purificación eliminan hasta el 99.9% de contaminantes, entregando agua pura y segura en cada grifo de su hogar.',
  wh_feature1: 'Prueba de Calidad del Agua Gratis',
  wh_feature2: 'Sistemas Certificados NSF/ANSI',
  wh_feature3: 'Garantía de Por Vida Disponible',
  wh_form_title: 'Programe Su Prueba de Agua Gratis',
  wh_form_sub: 'Sin costo, sin obligación. Probamos su agua y recomendamos la solución correcta.',
  wh_form_name: 'Nombre Completo *',
  wh_form_phone: 'Teléfono *',
  wh_form_email: 'Correo Electrónico *',
  wh_form_zip: 'Código Postal',
  wh_form_message: 'Cuéntenos sobre sus problemas de agua',
  wh_form_placeholder_name: 'Juan García',
  wh_form_placeholder_phone: '(555) 000-0000',
  wh_form_placeholder_email: 'juan@correo.com',
  wh_form_placeholder_zip: '30044',
  wh_form_placeholder_msg: 'Agua dura, mal sabor, olores...',
  wh_form_submit: 'Agendar Mi Prueba de Agua Gratis',
  wh_form_privacy: '100% Gratis · Sin obligación · Respetamos su privacidad',
  wh_success_title: '¡Solicitud Enviada!',
  wh_success_desc: 'Nos comunicaremos en 24 horas para programar su prueba de agua gratuita.',

  // WATER PROBLEMS
  wp_tag: 'Sepa Qué Hay en Su Agua',
  wp_title1: 'Lo Que Podría Estar Escondido',
  wp_title2: 'en Su Agua del Grifo',
  wp_desc: 'Su suministro de agua enfrenta desafíos únicos. Estos son los contaminantes más comunes encontrados en hogares de la región — y por qué la filtración es crítica.',
  wp1_title: 'Cloro y Cloraminas',
  wp1_desc: 'El cloro añadido al agua municipal para desinfección crea subproductos dañinos y causa un sabor y olor desagradable en el agua potable.',
  wp2_title: 'Plomo y Metales Pesados',
  wp2_desc: 'Las tuberías viejas liberan plomo y otros metales tóxicos en el agua del grifo. Incluso niveles bajos de plomo pueden causar daño neurológico grave, especialmente en niños.',
  wp3_title: 'Bacterias y Patógenos',
  wp3_desc: 'E. coli, giardia y otros microorganismos pueden contaminar el suministro de agua después de inundaciones o fallas de infraestructura, representando graves riesgos para la salud.',
  wp4_title: 'Minerales de Agua Dura',
  wp4_desc: 'El calcio y magnesio se acumulan en las tuberías, dañan los electrodomésticos, dejan sarro en los accesorios, causan piel seca y reducen la efectividad de jabones y detergentes.',
  wp5_title: 'Medicamentos y PFAS',
  wp5_desc: 'Rastros de medicamentos, herbicidas y "químicos eternos" como PFAS aparecen cada vez más en los suministros de agua y están vinculados a alteraciones hormonales y cáncer.',
  wp6_title: 'Nitratos y Escorrentía Agrícola',
  wp6_desc: 'La escorrentía de fertilizantes introduce altos niveles de nitratos en las aguas subterráneas, particularmente peligrosos para bebés y mujeres embarazadas.',
  wp_cta_title: '¿No sabe qué hay en su agua?',
  wp_cta_desc: 'Nuestros especialistas certificados visitarán su hogar y realizarán una prueba completa de calidad del agua — completamente gratis, sin obligación de compra.',
  wp_cta_btn: 'Prueba Gratis',

  // WATER SYSTEMS
  ws_tag: 'Nuestros Sistemas',
  ws_title1: 'La Solución Correcta',
  ws_title2: 'para Cada Hogar',
  ws_desc: 'Desde filtración para todo el hogar hasta sistemas de agua potable en un solo punto, ofrecemos una gama completa de soluciones de tratamiento de agua.',
  ws1_title: 'Filtración para Todo el Hogar',
  ws1_desc: 'Proteja cada grifo, ducha y electrodoméstico de su hogar. Nuestros sistemas filtran toda el agua entrante, eliminando sedimentos, cloro, metales pesados y más antes de que llegue a su familia.',
  ws1_f1: 'Eliminación de sedimentos y cloro',
  ws1_f2: 'Protege todos los electrodomésticos',
  ws1_f3: 'Cubre 1 a 6 baños',
  ws1_f4: 'Cambios de filtro de bajo mantenimiento',
  ws1_f5: 'Certificado NSF/ANSI 42/61',
  ws1_badge: 'Más Popular',
  ws2_title: 'Sistemas de Agua Potable',
  ws2_desc: 'Obtenga agua purificada premium directamente en su fregadero de cocina. Nuestros sistemas de ósmosis inversa debajo del mostrador ofrecen agua de excelente sabor con hasta 99% de eliminación de TDS.',
  ws2_f1: 'Ósmosis inversa de 5 etapas',
  ws2_f2: 'Hasta 99% de eliminación de TDS',
  ws2_f3: 'Grifo cromado dedicado',
  ws2_f4: 'Opción mineralizadora disponible',
  ws2_f5: 'Planes de servicio de filtro anuales',
  ws2_badge: 'Mejor Valor',
  ws3_title: 'Purificador de agua para el hogar',
  ws3_desc: 'Elimine los problemas de agua dura para siempre. Nuestros suavizadores con o sin sal eliminan el calcio y el magnesio, protegiendo sus tuberías y dejando su piel y cabello notablemente más suaves.',
  ws3_f1: 'Opciones con o sin sal',
  ws3_f2: 'Extiende la vida útil de los electrodomésticos',
  ws3_f3: 'Reduce la acumulación de sarro',
  ws3_f4: 'Piel y cabello más suaves',
  ws3_f5: 'Regeneración inteligente medida',
  ws_cta_btn: 'Obtener Cotización Gratis para Este Sistema',

  // WATER BENEFITS
  wb_tag: 'Por Qué Purificar Su Agua',
  wb_title1: '6 Beneficios que Cambian la Vida',
  wb_title2: 'del Agua Purificada',
  wb1_title: 'Mejor Salud para Su Familia',
  wb1_text: 'Reduzca la exposición al cloro, plomo y carcinógenos. El agua purificada apoya una mejor hidratación, cocina más saludable y tranquilidad mental.',
  wb2_title: 'Sabor y Frescura Superiores',
  wb2_text: 'Disfrute agua crujiente y limpia que realmente sabe bien — directo del grifo. Sin más desperdicio de agua embotellada ni contaminación plástica.',
  wb3_title: 'Ahorre en Agua Embotellada',
  wb3_text: 'La familia promedio gasta más de $1,200 al año en agua embotellada. Un sistema de purificación en casa se paga solo en el primer año.',
  wb4_title: 'Proteja Sus Electrodomésticos',
  wb4_text: 'El agua dura destruye los calentadores de agua, lavaplatos y lavadoras. El agua filtrada extiende la vida útil de los electrodomésticos y reduce los costos de mantenimiento.',
  wb5_title: 'Piel y Cabello más Suaves',
  wb5_text: 'Elimine los minerales ásperos que resecan la piel y apagan el cabello. El agua suave y purificada transforma su experiencia diaria de baño.',
  wb6_title: 'Opción Ecológica',
  wb6_text: 'Elimine miles de botellas plásticas de un solo uso por año. Un sistema de filtración en casa previene que más de 2,000 botellas lleguen a los vertederos anualmente.',

  // WINDOWS HERO
  wnh_back: 'Volver al Inicio',
  wnh_badge: 'Servicios de Ventanas',
  wnh_title1: 'Ventanas de Alta Calidad',
  wnh_title2: 'para Comodidad y Eficiencia',
  wnh_desc: 'Desde casas unifamiliares hasta edificios comerciales, nuestras ventanas premium ofrecen eficiencia energética superior, reducción de ruido y atractivo visual — instaladas profesionalmente y con garantía de por vida.',
  wnh_feature1: 'Certificado Energy Star',
  wnh_feature2: 'Residencial y Comercial',
  wnh_feature3: 'Garantía de Por Vida',
  wnh_form_title: 'Obtenga Su Cotización de Ventanas Gratis',
  wnh_form_sub: 'Cuéntenos sobre su proyecto y le proporcionaremos un presupuesto detallado sin obligación.',
  wnh_form_name: 'Nombre Completo *',
  wnh_form_phone: 'Teléfono *',
  wnh_form_email: 'Correo Electrónico *',
  wnh_form_address: 'Dirección de la Propiedad',
  wnh_form_service: 'Tipo de Servicio',
  wnh_form_message: 'Detalles del Proyecto',
  wnh_form_opt0: 'Seleccionar servicio...',
  wnh_form_opt1: 'Nueva Instalación',
  wnh_form_opt2: 'Reemplazo de Ventanas',
  wnh_form_opt3: 'Proyecto Residencial',
  wnh_form_opt4: 'Proyecto Comercial',
  wnh_form_opt5: 'Ventanas Resistentes a Impactos',
  wnh_form_placeholder_name: 'Juan García',
  wnh_form_placeholder_phone: '(555) 000-0000',
  wnh_form_placeholder_email: 'juan@correo.com',
  wnh_form_placeholder_address: '123 Calle Principal, Lawrenceville, GA',
  wnh_form_placeholder_msg: 'Número de ventanas, tipo de propiedad...',
  wnh_form_submit: 'Solicitar Mi Presupuesto Gratis',
  wnh_form_privacy: '100% Gratis · Sin obligación · Respetamos su privacidad',
  wnh_success_title: '¡Solicitud de Cotización Recibida!',
  wnh_success_desc: 'Nos comunicaremos en 24 horas con su presupuesto gratuito de ventanas.',

  // WINDOWS SERVICES
  wns_tag: 'Nuestros Servicios de Ventanas',
  wns_title1: 'Soluciones Completas de Ventanas',
  wns_title2: 'para Cada Propiedad',
  wns_desc: 'Ya sea que esté construyendo nuevo, reemplazando ventanas viejas o mejorando a protección de impacto — lo manejamos todo con artesanía experta.',
  wns1_title: 'Instalación de Ventanas Residenciales',
  wns1_desc: 'Construcción nueva o hogares existentes — instalamos ventanas eficientes en todos los estilos y tamaños. Nuestros instaladores certificados garantizan un ajuste perfecto y acabado impecable.',
  wns1_f1: 'Opciones de panel simple, doble y triple',
  wns1_f2: 'Batiente, bahía, deslizante y más',
  wns1_f3: 'Tamaños personalizados disponibles',
  wns1_f4: 'Impermeabilización profesional',
  wns2_title: 'Reemplazo de Ventanas',
  wns2_desc: 'Actualice sus ventanas viejas, con corrientes de aire o dañadas con alternativas modernas y eficientes en energía. La mayoría de los reemplazos se completan en un solo día.',
  wns2_f1: 'Reemplazo en el mismo día disponible',
  wns2_f2: 'Remoción y disposición de ventanas viejas',
  wns2_f3: 'Inspección y reparación de marcos',
  wns2_f4: 'Acabados interiores y exteriores',
  wns3_title: 'Servicios de Ventanas Comerciales',
  wns3_desc: 'Desde tiendas hasta edificios de oficinas de varios pisos, ORPM entrega soluciones de ventanas de grado comercial que reducen costos de energía y cumplen todos los códigos de construcción.',
  wns3_f1: 'Sistemas de vidrio para locales',
  wns3_f2: 'Acristalamiento resistente a impactos',
  wns3_f3: 'Sistemas de muro cortina',
  wns3_f4: 'Cumplimiento ADA y de código',
  wns4_title: 'Ventanas Resistentes a Impactos',
  wns4_desc: 'Nuestras ventanas de impacto cumplen con estrictas especificaciones y protegen su hogar de tormentas, robos y daños por UV.',
  wns4_f1: 'Certificadas contra tormentas',
  wns4_f2: 'Protección contra huracanes',
  wns4_f3: 'Mayor seguridad',
  wns4_f4: 'Elegible para descuento en seguro',

  // WINDOWS ENERGY
  wne_tag: 'Eficiencia Energética',
  wne_title1: 'Ventanas que se Pagan',
  wne_title2: 'Solas',
  wne_desc: 'Nuestras ventanas certificadas Energy Star ofrecen ahorros medibles desde el primer día. Vea los números reales detrás de la inversión.',
  wne_stat1_val: 'Hasta 40%',
  wne_stat1_label: 'Reducción en Costos de Calefacción y Refrigeración',
  wne_stat2_val: '2x Mejor',
  wne_stat2_label: 'Aislamiento vs. Ventanas de Panel Simple',
  wne_stat3_val: 'Más del 80%',
  wne_stat3_label: 'Bloqueo de Rayos UV para Proteger Interiores',
  wne_stat4_val: 'Más de $500',
  wne_stat4_label: 'Ahorro Anual en Facturas de Energía',
  wne_comfort_title: 'Comodidad más Allá del Ahorro Energético',
  wne_c1_title: 'Reducción de Ruido Superior',
  wne_c1_text: 'Nuestras ventanas de múltiples paneles reducen drásticamente el ruido exterior hasta en un 50%, creando un ambiente hogareño más tranquilo y pacífico.',
  wne_c2_title: 'Comodidad Durante Todo el Año',
  wne_c2_text: 'El aislamiento avanzado mantiene temperaturas interiores constantes, manteniendo su hogar fresco en verano y cálido en las noches de invierno.',
  wne_c3_title: 'Vidrio sin Condensación',
  wne_c3_text: 'Nuestras ventanas de doble y triple panel rellenas de gas eliminan la condensación interior, previniendo moho, hongos y daños por agua.',
  wne_c4_title: 'Optimización de Luz Natural',
  wne_c4_text: 'Obtenga toda la luz natural que desea sin el calor ni los daños por UV. Nuestros recubrimientos de selección espectral transmiten la luz visible bloqueando infrarrojo y UV.',

  // WINDOWS PROCESS
  wnp_tag: 'Nuestro Proceso',
  wnp_title1: 'Fácil como 1, 2, 3',
  wnp_title2: '— En Realidad 5',
  wnp_desc: 'Hicimos el proceso de instalación de ventanas lo más simple y sin estrés posible. Aquí está exactamente lo que puede esperar.',
  wnp1_num: '01',
  wnp1_title: 'Consulta Gratuita',
  wnp1_text: 'Llámenos o solicite en línea. Discutimos sus necesidades, plazos y presupuesto sin ninguna presión.',
  wnp2_num: '02',
  wnp2_title: 'Medición en el Hogar',
  wnp2_text: 'Nuestro especialista visita su propiedad para tomar medidas precisas y evaluar los requisitos de instalación.',
  wnp3_num: '03',
  wnp3_title: 'Cotización Detallada',
  wnp3_text: 'Reciba una cotización transparente y detallada que incluye productos, mano de obra y garantía. Sin sorpresas.',
  wnp4_num: '04',
  wnp4_title: 'Instalación Experta',
  wnp4_text: 'Nuestro equipo certificado instala sus ventanas de manera eficiente, a tiempo y con total respeto por su hogar.',
  wnp5_num: '05',
  wnp5_title: 'Inspección Final',
  wnp5_text: 'Le mostramos cada ventana, confirmamos su satisfacción y le proporcionamos toda la documentación de garantía.',
  wnp_cta_title: '¿Listo para Empezar?',
  wnp_cta_desc: 'La mayoría de los proyectos se completan en 1 a 2 días hábiles. Solicite su presupuesto gratis hoy.',
  wnp_cta_btn: 'Solicitar Presupuesto Gratis',

  // ABOUT PAGE
  nav_about: 'Sobre Nosotros',
  about_hero_badge: 'Nuestra Historia',
  about_hero_title1: 'Su Socio de Confianza en',
  about_hero_title2: 'Mejoras para el Hogar',
  about_hero_desc: 'ORPM Investment LLC fue fundada con una misión simple pero poderosa: mejorar la calidad de vida de los propietarios y negocios a través de mejor agua y mejores hogares. Con sede en Lawrenceville, Georgia, nos hemos convertido en uno de los nombres más confiables de la región en purificación de agua y soluciones de ventanas.',
  about_hero_stat1_val: '15+',
  about_hero_stat1_label: 'Años de Experiencia',
  about_hero_stat2_val: '2,000+',
  about_hero_stat2_label: 'Clientes Satisfechos',
  about_hero_stat3_val: '2',
  about_hero_stat3_label: 'Servicios Especializados',
  about_hero_stat4_val: '100%',
  about_hero_stat4_label: 'Tasa de Satisfacción',

  about_mission_tag: 'Nuestro Propósito',
  about_mission_title: 'Misión y Visión',
  about_mission_label: 'Nuestra Misión',
  about_mission_text: 'Mejorar la calidad de vida de cada propietario y negocio al que servimos — a través de sistemas avanzados de purificación de agua que protegen la salud, y ventanas de alto rendimiento que mejoran la comodidad, eficiencia y el valor de la propiedad. Creemos que cada familia merece agua limpia y un hogar seguro y hermoso.',
  about_vision_label: 'Nuestra Visión',
  about_vision_text: 'Convertirnos en el socio líder de mejoras para el hogar en Georgia, reconocidos por nuestro compromiso con la calidad, nuestra honestidad con cada cliente y nuestra capacidad de generar mejoras reales y medibles en los hogares y vidas de las comunidades a las que servimos.',
  about_story_label: 'Nuestra Historia',
  about_story_text: 'ORPM Investment LLC nació de una experiencia personal. Nuestro fundador fue testigo de primera mano de cómo el agua contaminada y las ventanas anticuadas afectaban silenciosamente la salud y comodidad de las familias — y decidió construir una empresa que pudiera solucionar ambos problemas. Comenzando con un pequeño equipo y un gran compromiso con la calidad, hemos crecido para servir a miles de familias en Lawrenceville y el gran Georgia. Hoy nos enorgullece ser un equipo de profesionales certificados que brindan soluciones premium a precios honestos.',

  about_values_tag: 'Lo Que Defendemos',
  about_values_title: 'Nuestros Valores Fundamentales',
  about_values_desc: 'Estos no son solo palabras en una pared. Estos valores guían cada interacción, cada instalación y cada decisión que tomamos en ORPM.',
  about_val1_title: 'Calidad Primero',
  about_val1_desc: 'Solo instalamos equipos y usamos materiales que cumplen con los más altos estándares de la industria. Sin atajos, sin compromisos — nunca.',
  about_val2_title: 'Basados en la Confianza',
  about_val2_desc: 'Precios transparentes, evaluaciones honestas y cero tácticas de venta bajo presión. Nos ganamos su confianza antes de ganarnos su negocio.',
  about_val3_title: 'Enfoque en el Cliente',
  about_val3_desc: 'Su satisfacción es nuestra máxima prioridad — desde la primera llamada hasta años de soporte post-instalación. Estamos aquí a largo plazo.',
  about_val4_title: 'Innovación',
  about_val4_desc: 'Nos mantenemos a la vanguardia de los últimos avances en tratamiento de agua y tecnología de ventanas para brindarle las soluciones más efectivas disponibles.',
  about_val5_title: 'Compromiso Comunitario',
  about_val5_desc: 'Somos miembros orgullosos de la comunidad de Lawrenceville. Negocios locales, familias locales y calidad local — eso es lo que somos.',
  about_val6_title: 'Integridad Siempre',
  about_val6_desc: 'Hacemos lo que decimos, decimos lo que hacemos. Nuestra reputación es nuestro activo más valioso y lo protegemos en cada trabajo.',

  about_map_tag: 'Encuéntrenos',
  about_map_title: 'Visite Nuestra Oficina',
  about_map_desc: 'Estamos ubicados convenientemente en Lawrenceville, Georgia. Visítenos, llame o escríbanos — nuestro equipo siempre está feliz de ayudar.',
  about_map_address_label: 'Dirección',
  about_map_phone_label: 'Teléfono',
  about_map_email_label: 'Correo',
  about_map_hours_label: 'Horarios',
  about_map_address_val: '3202 Lealand Pl Ln\nLawrenceville, GA 30044',
  about_map_hours_val: 'Lun – Vie: 8:00 AM – 6:00 PM\nSábado: 9:00 AM – 3:00 PM\nDomingo: Cerrado',
  about_map_directions: 'Cómo Llegar',
  about_cta_tag: 'Trabajemos Juntos',
  about_cta_title1: '¿Listo para Mejorar',
  about_cta_title2: 'Su Hogar?',
  about_cta_desc: 'Ya sea que necesite agua más limpia, mejores ventanas o ambas cosas — nuestro equipo está listo para ayudar. Comience con una consulta gratuita, sin compromiso.',
  about_cta_btn1: 'Prueba de Agua Gratis',
  about_cta_btn2: 'Cotización de Ventanas Gratis',

  // CONTACT PAGE
  nav_contact: 'Contacto',
  contact_hero_badge: 'Contáctenos',
  contact_hero_title1: 'Solicite Su Consulta',
  contact_hero_title2: 'Gratuita Hoy',
  contact_hero_desc: 'Ya sea que necesite una prueba de agua, cotización de ventanas o simplemente tenga preguntas — nuestro equipo está aquí para usted. Complete el formulario y le responderemos en 24 horas.',

  contact_form_title: 'Solicitar Cita o Presupuesto Gratis',
  contact_form_sub: 'Sin costo. Sin obligación. Nuestros especialistas se comunicarán con usted en 24 horas.',
  contact_form_name: 'Nombre Completo *',
  contact_form_phone: 'Teléfono *',
  contact_form_email: 'Correo Electrónico *',
  contact_form_address: 'Dirección de la Propiedad',
  contact_form_service: 'Servicio de Interés *',
  contact_form_service_opt0: 'Seleccione un servicio...',
  contact_form_service_opt1: 'Prueba de Calidad del Agua Gratis',
  contact_form_service_opt2: 'Sistema de Purificación de Agua',
  contact_form_service_opt3: 'Suavizador de Agua',
  contact_form_service_opt4: 'Cotización de Ventanas Gratis',
  contact_form_service_opt5: 'Instalación de Ventanas',
  contact_form_service_opt6: 'Reemplazo de Ventanas',
  contact_form_service_opt7: 'Ambos Servicios (Agua + Ventanas)',
  contact_form_message: 'Cuéntenos sobre su proyecto o preguntas',
  contact_form_ph_name: 'Juan García',
  contact_form_ph_phone: '(555) 000-0000',
  contact_form_ph_email: 'juan@correo.com',
  contact_form_ph_address: '123 Calle Principal, Lawrenceville, GA',
  contact_form_ph_message: 'Describa sus necesidades, problemas actuales o cualquier pregunta que tenga...',
  contact_form_submit: 'Enviar Mi Solicitud',
  contact_form_privacy: '100% Gratis · Sin obligación · Respetamos su privacidad',
  contact_form_success_title: '¡Solicitud Enviada con Éxito!',
  contact_form_success_desc: '¡Gracias! Uno de nuestros especialistas se comunicará con usted en 24 horas para programar su consulta gratuita.',
  contact_form_error: 'Algo salió mal. Por favor intente de nuevo o llámenos directamente.',

  contact_info_title: 'Información de Contacto',
  contact_info_address_label: 'Nuestra Ubicación',
  contact_info_phone_label: 'Llámenos',
  contact_info_email_label: 'Escríbanos',
  contact_info_hours_label: 'Horario de Atención',
  contact_info_address: '3202 Lealand Pl Ln\nLawrenceville, GA 30044',
  contact_info_hours: 'Lun – Vie: 8:00 AM – 6:00 PM\nSábado: 9:00 AM – 3:00 PM\nDomingo: Cerrado',
  contact_info_directions: 'Cómo Llegar',
  contact_info_response: 'Tiempo promedio de respuesta: menos de 2 horas en horario laboral.',

  contact_why_title: '¿Por Qué Contactar a ORPM?',
  contact_why1_title: 'Consultas Gratuitas',
  contact_why1_text: 'Cada cotización y prueba de agua es 100% gratuita. Sin cargos ocultos, sin presión.',
  contact_why2_title: 'Respuesta Rápida',
  contact_why2_text: 'Respondemos en 24 horas — usualmente el mismo día en horario laboral.',
  contact_why3_title: 'Asesoramiento Experto',
  contact_why3_text: 'Nuestros especialistas certificados le darán recomendaciones honestas y personalizadas.',

  // BOOKING CALENDAR
  booking_section_tag: 'Agenda Tu Cita',
  booking_section_title: 'Reserva una Consulta Gratuita',
  booking_section_desc: 'Elige el día y horario que mejor te convenga. Nuestros especialistas están listos para atenderte.',
  booking_step_date: 'Selecciona una Fecha',
  booking_step_time: 'Selecciona un Horario',
  booking_step_form: 'Confirma Tu Reserva',
  booking_prev_month: 'Mes anterior',
  booking_next_month: 'Mes siguiente',
  booking_no_slots: 'No hay horarios disponibles para este día.',
  booking_label_name: 'Nombre Completo',
  booking_label_phone: 'Teléfono',
  booking_label_notes: 'Notas adicionales (opcional)',
  booking_ph_name: 'Juan García',
  booking_ph_phone: '(555) 000-0000',
  booking_ph_notes: 'Cuéntanos sobre tu consulta, tipo de servicio de interés...',
  booking_selected_date: 'Fecha:',
  booking_selected_time: 'Horario:',
  booking_modify_time: 'Cambiar horario',
  booking_submit: 'Confirmar Reserva',
  booking_submitting: 'Enviando...',
  booking_success_title: '¡Cita Confirmada!',
  booking_success_desc: 'Tu reserva fue registrada exitosamente. Nos comunicaremos contigo para confirmar los detalles.',
  booking_error: 'Algo salió mal. Por favor intenta de nuevo o llámanos directamente.',
  booking_back: 'Hacer otra reserva',
  booking_loading: 'Cargando disponibilidad...',
  booking_required: '*',
};

export default translation;
